import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import classes from "../../Auth.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Loader from "../../../../components/Loader/Loader";
import Button from "../../../../components/Button/Button";
import Card from "../../../../components/Card/Card";
import { BASE_PATH_TO_VIEW_IP_ADDRESS } from "../../../../base_routes_paths/auth_paths";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";
import { IPAddressServices } from "../../../../services/auth_services";

const UpdateIpAddress = () => {
    const { token } = AUTH_CONTEXT();
    const [isLoading, setIsLoading] = useState(false);
    const [IsLoaderLoading, setIsLoaderLoading] = useState(false);
    const [IPAddress, setIPAddress] = useState([""]);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const navigate = useNavigate();

    const addValueField = () => {
        setIPAddress(prevState => [...prevState, '']);
    };

    const removeValueField = (index) => {
        setIPAddress(prevState => {
            const updatedIPList = [...prevState];
            updatedIPList.splice(index, 1);
            return updatedIPList;
        });
    };

    const FetchResponseGetAllUserDetails = async () => {
        try {
            let response = await IPAddressServices.getAllIPAddress(token, navigate);

            setIsLoaderLoading(true);
            setIsDataFetched(true);
            toast.success("Data fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return response.data;
        } catch (e) {
            setIsLoaderLoading(false);
            setIsDataFetched(false);
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        if (!isDataFetched) {
            FetchResponseGetAllUserDetails()
                .then((result) => {
                    setIPAddress(result[0].IpAddressList);
                })
                .catch((err) => console.log(err));
        }
    }, []);

    const submitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true);
        const nonEmptyIPAddresses = IPAddress.filter(ip => ip.trim() !== '');
        const FetchApi = async () => {
            try {
                let response = await IPAddressServices.updateIpAddress(token, navigate, nonEmptyIPAddresses);

                setIsLoading(false);
                if (response.status === 207) {
                    return toast.error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
                }
                navigate(BASE_PATH_TO_VIEW_IP_ADDRESS)
                toast.success("Data added successfully!!", {
                    position: "bottom-left",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } catch (e) {
                setIsLoading(false);
                toast.error(e.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        };
        FetchApi();
    };

    return (
        !IsLoaderLoading ? <Loader /> :
            <div className={classes.crumbs}>
                <Breadcrumbs aria-label="breadcrumb" >
                    <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                        Dashboard
                    </Link>
                    <Typography color="text.primary">
                        Auth
                    </Typography>
                    <Typography color="text.primary">Update IP Address List</Typography>
                </Breadcrumbs>
                <form onSubmit={submitHandler}>
                    <Card className={classes.input}>
                        <div className={classes.Main_div}>Update Allowed IP Address List</div>
                        <div className={classes.control} style={{ marginBottom: "1rem" }}>
                            <div className={classes.subfields}>
                                <label htmlFor="IpAddressList">IpAddressList :</label>
                                {IPAddress.map((ip, index) => (
                                    <div key={index}>
                                        <input
                                            value={ip}
                                            type='text'
                                            onChange={(event) => {
                                                const updatedIPList = [...IPAddress];
                                                updatedIPList[index] = event.target.value;
                                                setIPAddress(updatedIPList);
                                            }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => removeValueField(index)}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    onClick={addValueField}
                                    style={{
                                        marginTop: "10px",
                                    }}
                                >
                                    Add More Values...
                                </button>
                            </div>
                        </div>
                        {!isLoading && <Button type="submit">Update</Button>}
                        {isLoading && <p color="white">Sending request...</p>}
                    </Card>
                </form>
            </div>
    )
}

export default UpdateIpAddress;
